import { Component, ElementRef, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from '../../universal-config';

@Component({
  selector: 'nns-note-text',
  styles: [`
    :host {
      display:block;
      color:rgba(0, 0, 0, 0.8);
    }
    .note-text-holder {
      position:relative;
      z-index:10;
      overflow:hidden;
    }
    .note-text  {
      font-family:'Noto Sans', Arial, Helvetica, Sans-serif;
      font-size:18px;
      line-height:1.5;
      position:relative;
      overflow:auto;
    }
    .note-text /deep/ * {margin:0; padding:0;}
    .note-text /deep/ h1,
    .note-text /deep/ h2,
    .note-text /deep/ h3,
    .note-text /deep/ h4,
    .note-text /deep/ h5,
    .note-text /deep/ h6 {padding:10px 0; font-weight:bold; color:#3E4849; line-height:1.3;}
    .note-text /deep/ h1 {font-size:1.4em;}
    .note-text /deep/ h2 {font-size:1.35em;}
    .note-text /deep/ h3 {font-size:1.3em;}
    .note-text /deep/ h4 {font-size:1.25em;}
    .note-text /deep/ h5 {font-size:1.2em;}
    .note-text /deep/ h6 {font-size:1.1em;}
    .note-text /deep/ p {padding:10px 0;}
    .note-text /deep/ ul,
    .note-text /deep/ ol {padding:10px 0 10px 20px;}
    .note-text /deep/ li {padding:0 0 10px 0;}
    .note-text /deep/ li:last-of-type {padding: 0;}
    .note-text /deep/ li ol,
    .note-text /deep/ li ul {padding: 10px 0 0 20px;}
    .note-text /deep/ blockquote {font-style:italic; margin:0 0 30px 30px;}
    .note-text /deep/ blockquote p:last-child {padding:0;}
    .note-text /deep/ table {
      border-spacing:0;
      border-collapse:collapse;
      width:100%;
      margin:0 0 20px 0;
    }
    .note-text /deep/ table tr td,
    .note-text /deep/ table tr th {
      vertical-align:top;
      text-align:left;
      padding:10px;
      border:2px solid #cfd1d3;
    }

    .note-text /deep/ .nns-table-holder {
      overflow:auto;
    }

    .note-text /deep/ img {display:block; max-width:100%; height:auto; margin:20px 0;}

    .note-text /deep/ img.big-image {cursor: pointer}

    .note-text /deep/ ul.nn-checkbox-list li {
      list-style: none;
      pointer-events: none;
    }

    .note-text /deep/ ul.nn-checkbox-list li:before{
      content: "";
      display: inline-block;
      margin-right: 5px;
    }

    .note-text /deep/ img {
      cursor: pointer;
    }

    @media only screen and (max-width: 1024px) {
      .note-text {
        font-size:16px;
      }
    }

    @media only screen and (max-width: 768px) {
      .note-text /deep/ h1 {font-size:1.3em;}
      .note-text /deep/ h2 {font-size:1.25em;}
      .note-text /deep/ h3 {font-size:1.2em;}
      .note-text /deep/ h4 {font-size:1.15em;}
      .note-text /deep/ h5 {font-size:1.1em;}
      .note-text /deep/ h6 {font-size:1.05em;}
    }

    :host-context(.nns-theme-night) .note-text /deep/ table tr td,
    :host-context(.nns-theme-night) .note-text /deep/ table tr th {
      border-color:#000;
    }

    :host-context(.nns-theme-night) {filter:invert(100%);}
    :host-context(.nns-theme-night) .note-text /deep/ img,
    :host-context(.nns-theme-night) .note-text /deep/ ul.nn-checkbox-list li:before {filter:invert(100%);}

    :host-context(.no-flex) .note-text {
      overflow:inherit;
    }
    :host-context(.no-flex) {
      color:#000;
    }
    :host-context(.nns-theme-night.no-flex) {
      color:#fff;
    }

    @media print {
      :host-context(.nns-theme-night),
      :host-context(.nns-theme-night) .note-text,
      :host-context(.nns-theme-night) .note-text /deep/ img,
      :host-context(.nns-theme-night) .note-text /deep/ ul.nn-checkbox-list li:before {
        filter: none;
        -webkit-filter: none;
      }
      :host-context(.nns-theme-night.no-flex) .note-text,
      :host-context(.no-flex),
      :host-context(.nns-theme-night.no-flex) {
        color:#000;
      }

      :host-context(.nns-theme-night) .note-text /deep/ table tr td,
      :host-context(.nns-theme-night) .note-text /deep/ table tr th {
        border-color:#000;
      }
      .note-text /deep/ h1,
      .note-text /deep/ h2,
      .note-text /deep/ h3,
      .note-text /deep/ h4,
      .note-text /deep/ h5,
      .note-text /deep/ h6,
      .note-text{
        color: #000;
      }
    }
  `],
  template: `
    <div class="note-text-holder">
      <div
        [class]="alignCenter ? 'note-text note-text-center' : 'note-text'"
        [innerHTML]="text"
        (click)="textClick($event)"
        (mouseover)="textMouseOver($event)"
      ></div>
    </div>
  `
})

export class NoteTextComponent {
  @Input() text;
  @Input() attachments;
  alignCenter = false;

  constructor(
    public _elementRef: ElementRef,
    @Inject('isBrowser') public isBrowser: boolean,
    public _router: Router,
    private config: Config,
  ) { }

  ngOnInit() {
    if(this.text) {
      const countDiv = String(this.text).split('<div>').length - 1;
      const countImg = String(this.text).split('<img').length - 1;

      if(countDiv === 1 && countImg > 0) {
        this.alignCenter = true;
      }
    }
  }

  textClick(event) {
    if (this.isEventSourceBigImage(event)) {
      if (event.target && event.target.dataset && event.target.dataset.attachmentId) {
        const attachment = this.findAttachment(event.target.dataset.attachmentId);
        this.openImageAttachment(attachment);
        return;
      }

      const { src } = event.target;
      window.open(src, '_blank');
      return;
    }
  }

  openImageAttachment(attachment) {
    if (!attachment) {
      console.error("NoteComponent: No attachment to open");
    }
    this._router.navigate([attachment.imageURL]);
  }

  isEventSourceBigImage(event) {
    if (event && event.target && event.target.nodeName === 'IMG') {
      const { naturalWidth, width, src } = event.target;
      if (naturalWidth > width) {
        return true;
      }
    }
    return false;
  }

  findAttachment(attachmentId) {
    let attachment;
    this.attachments.forEach((a) => {
      if (a.globalId === attachmentId) {
        attachment = a;
      }
    });
    return attachment;
  }

  ngAfterViewChecked() {
    if (this.isBrowser) {
      this.handleLinksInText()
    }
  }

  handleLinksInText() {
    const nodes = this._elementRef.nativeElement.querySelectorAll('a');
    let i;
    for (i = 0; i < nodes.length; ++i) {
      const link = nodes[i];
      if (link.nnIsAfterLinkClick) {
        return;
      }
      link.addEventListener('click', afterLinkClick(link));
      link.nnIsAfterLinkClick = true;
    }
  }

  textMouseOver(event) {
    if (this.isEventSourceBigImage(event)) {
      const { target } = event;
      if (!target || !target.className) { return }
      if (target.className.indexOf('big-image') === -1) {
        target.className += ' big-image';
        target.title = 'Click to view in full size';
      }
    }
  }
}

function afterLinkClick(node) {
  return (event) => {
    window.open(node.href, '_blank');
    event.preventDefault();
  };
}
